import config from "../../../config";
import { getSiteById, Site } from "./reducer";
import {
  SITES_FETCH_ALL_PENDING,
  SITES_FETCH_ALL_FULFILLED,
  SITES_FETCH_ALL_REJECTED,
} from "./constants";
import { AppDispatch, AppGetState } from "../../../store";
import { globalContextRequest } from "../../globalContextRequest";

const { csuApi } = config.endpoints;

export const fetchSites = (customerId: string) => async (
  dispatch: AppDispatch,
): Promise<Site[]> => {
  try {
    dispatch({ type: SITES_FETCH_ALL_PENDING });
    const { data } = await dispatch(
      globalContextRequest({
        method: "GET",
        url: `${csuApi}/customers/${customerId}/sites`,
      }),
    );
    const { sites } = data;
    // TODO: adding customer property
    sites.map((site: Site) => (site.customer = customerId));
    dispatch({ type: SITES_FETCH_ALL_FULFILLED, payload: sites });
    return sites;
  } catch (error) {
    dispatch({ type: SITES_FETCH_ALL_REJECTED, payload: error });
    throw error;
  }
};

export function ensureSite(customerId: string, siteId: string) {
  return function(dispatch: AppDispatch, getState: AppGetState): Promise<Site> {
    const state = getState().sites;
    const site = getSiteById(state, customerId, siteId);
    if (site) {
      return Promise.resolve(site);
    }
    return fetchSites(customerId)(dispatch).then(() =>
      getSiteById(getState().sites, customerId, siteId),
    );
  };
}
